module.exports = __webpack_public_path__ + "stockLibrary/login-fc6ec47b79a043dc8d6c5c2cc1bede32.png";